
export default {
  name: 'EnterCodeStep',
  data() {
    return {
      code: ''
    };
  }
};
